import { createServerFn } from "@tanstack/react-start";

// Public read-only resolver: callers pass specific media IDs (only those
// referenced by published slideshow configs in app_settings) and get back
// the display URL + filename. Prevents anonymous bulk-enumeration of the
// media_library table while still letting public pages render slideshows.
export const resolvePublicMedia = createServerFn({ method: "POST" })
  .inputValidator((input: { ids: string[] }) => {
    if (!input || !Array.isArray(input.ids)) return { ids: [] as string[] };
    const ids = input.ids
      .filter((v): v is string => typeof v === "string")
      .slice(0, 100);
    return { ids };
  })
  .handler(async ({ data }) => {
    if (data.ids.length === 0)
      return [] as {
        id: string;
        url: string;
        alt: string;
        variants: Record<string, string> | null;
      }[];
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: rows, error } = await supabaseAdmin
      .from("media_library")
      .select("id, webp_url, original_url, filename, variants")
      .in("id", data.ids);
    if (error) throw new Error(error.message);
    return (rows ?? []).map((m: any) => ({
      id: m.id as string,
      url: (m.webp_url as string) || (m.original_url as string),
      alt: (m.filename as string) || "",
      variants: (m.variants as Record<string, string> | null) ?? null,
    }));
  });

